<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        :todo-list.sync="todoList"
        show-to-do
        @reloadData="requestData()"
        @todoAdd="todoAddFun"
        @todoCheck="todoCheckFun"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.paymentUnitName"
              placeholder="请输入付款单位名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.voucherNo"
              placeholder="请输入凭证号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-date-picker
              v-model="masterList.tableQuery.search.searchStartDate"
              type="date"
              placeholder="选择收款开始日期"
              style="width:100%"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
          </el-col>
          <el-col :span="3">
            <el-date-picker
              v-model="masterList.tableQuery.search.searchEndDate"
              type="date"
              placeholder="选择收款结束日期"
              style="width:100%"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.search.status"
              placeholder="请选择单据状态"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        :total-amount="totalAmount"
        :is-show-total="isShowTotal"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @edit="editFun(arguments)"
        @remove="removeFun(arguments)"
        @check="checkFun(arguments)"
        @unCheck="unCheckFun(arguments)"
        @view="viewFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
        @getTotal="totalFun"
      />
    </div>

    <!-- 修改 -->
    <add-edit-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      @reloadData="loadTableData()"
    />

    <!-- 查看 -->
    <view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogViewVisible"
    />

    <!-- 待办列表 -->
    <task-list-dialog
      :dialog-visible.sync="dialogTaskVisible"
      dialog-title="待收款清单"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 修改
import addEditDialog from './components/addEditDialog'
// 查看
import viewDialog from './components/viewDialog'
// 待办列表
import taskListDialog from './components/taskListDialog'
// 数据请求
import { loadReceiveVoucherListDataApi, loadReceiveVoucherExportDataApi, saveOrUpdateReceiveVoucherApi, countReceiveVoucherTodoNumberApi } from '@/api/receiveVoucher'
import { countReceivableTodoNumberApi } from '@/api/receivable'

export default {
  name: 'ReceiveVoucher',
  components: {
    CustomTable,
    TableOperation,
    addEditDialog,
    viewDialog,
    taskListDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'receive_voucher_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['receipt_voucher_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['receipt_voucher_check'],
            prop: 'checkFun',
            label: '复核',
            method: 'check'
          },
          {
            permissionSigns: ['receipt_voucher_uncheck'],
            prop: 'unCheckFun',
            label: '反复核',
            method: 'unCheck'
          },
          {
            permissionSigns: ['receipt_voucher_delete'],
            prop: 'removeFun',
            label: '作废',
            method: 'remove'
          },
          {
            permissionSigns: ['receipt_voucher_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['receipt_voucher_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            voucherNo: '',
            paymentUnitName: '',
            searchStartDate: '',
            searchEndDate: '',
            status: ''
          }
        }
      },
      // 待办
      todoList: [
        {
          permissionSigns: ['receipt_voucher_add'],
          label: '待收款清单',
          method: 'todoAdd',
          count: 0
        },
        {
          permissionSigns: ['receipt_voucher_check'],
          label: '待复核的付款单',
          method: 'todoCheck',
          count: 0
        },
      ],
      id: null, // 选中的单据ID
      statusOptions: [{ value: 1, label: '制单' }, { value: 2, label: '复核' }],
      eventType: '',
      dialogTitle: '',
      totalAmount: 0, // 合计结果
      isShowTotal: false, // 合计显示
      dialogAddEditVisible: false,
      dialogViewVisible: false,
      dialogTaskVisible: false
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', label: '省区', filterColumn: 'rv.province_name', width: 90 },
      { prop: 'cityName', label: '城市', filterColumn: 'rv.city_name', width: 100 },
      { prop: 'paymentUnitName', label: '付款单位', filterColumn: 'pu.unit_name', width: 180 },
      { prop: 'receiveUnitName', label: '收款单位', filterColumn: 'ru.unit_name', width: 180 },
      { prop: 'receiveBankName', label: '收款银行', filterColumn: 'rv.receive_bank_name', width: 150 },
      { prop: 'receiveBankNo', label: '收款账号', filterColumn: 'rv.receive_bank_no', width: 150 },
      { prop: 'receiveDateValue', label: '收款日期', filterColumn: 'rv.receive_date', width: 120, isBetween: true },
      { prop: 'voucherNo', label: '凭证号', filterColumn: 'rv.voucher_no', width: 150 },
      { prop: 'receiveAmount', label: '收款金额', filterColumn: 'rv.receive_amount', width: 120, allowSum: true, formatPrice: true },
      { prop: 'differenceAmount', label: '差异金额', filterColumn: 'rv.difference_amount', width: 120, allowSum: true, formatColorPrice: true },
      { prop: 'invoiceNos', label: '发票号', filterColumn: 'rie.invoice_nos', width: 200 },
      { prop: 'statusValue', label: '状态', filterColumn: 'rv.status', filterValue: 'status', filterArray: this.statusOptions, width: 100 },
      { prop: 'remark', label: '备注', filterColumn: 'rv.remark', width: 180 },
      { prop: 'creator', filterColumn: 'rv.creator', label: '制单人', width: 100 },
      { prop: 'createTimeValue', filterColumn: 'rv.create_time', label: '制单时间', width: 150, isBetween: true },
      { prop: 'checker', filterColumn: 'rv.checker', label: '复核人', width: 100 },
      { prop: 'checkTimeValue', filterColumn: 'rv.check_time', label: '复核时间', width: 150, isBetween: true },
      { prop: 'operatorName', filterColumn: 'rv.operator_name', label: '操作人', width: 100 },
      { prop: 'operationTimeValue', filterColumn: 'rv.operation_time', label: '操作时间', width: 150, isBetween: true }
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.isShowTotal = false
      this.masterList.tableLoading = true
      loadReceiveVoucherListDataApi({ condition: JSON.stringify(this.masterList.tableQuery) }).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data || []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal || 0
      }).catch()
      this.getTodoCount()
    },
    // 获取待办任务数量
    getTodoCount () {
      // 待收款清单数量
      countReceivableTodoNumberApi({ todoReceive: 'true' }).then(res => {
        this.todoList[0].count = res.data || 0
      })
      // 待复核收款单数量
      countReceiveVoucherTodoNumberApi({ status: 1 }).then(res => {
        this.todoList[1].count = res.data || 0
      })
    },
    // 合计方法
    totalFun (fieldColumn, computedTotalObj) {
      this.masterList.tableLoading = true
      let sumCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      sumCondition.isSumTotal = true
      sumCondition.sumField = computedTotalObj.filterColumn
      loadReceiveVoucherListDataApi(sumCondition).then(response => {
        this.masterList.tableLoading = false
        this.isShowTotal = true
        this.totalAmount = response.data ? response.data.sumTotal : 0
      }).catch()
    },
    // 收款待办清单
    todoAddFun () {
      this.dialogTaskVisible = !this.dialogTaskVisible
    },
    // 复核待办
    todoCheckFun () {
      this.masterList.tableQuery.search = {
        voucherNo: '',
        paymentUnitName: '',
        searchStartDate: '',
        searchEndDate: '',
        status: 1
      }
      this.loadTableData()
    },
    // 修改
    editFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要修改的收款单', type: 'warning' })
        return
      } else if (args[0].status === 2) {
        this.$message({ message: '收款单不在制单状态，不能修改', type: 'warning' })
        return
      }
      this.id = args[0].id
      this.eventType = 'edit'
      this.dialogTitle = '修改收款单'
      this.dialogAddEditVisible = !this.dialogAddEditVisible
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要查看的收款单', type: 'warning' })
        return
      }
      this.id = args[0].id
      this.eventType = 'view'
      this.dialogTitle = '查看收款单'
      this.dialogViewVisible = !this.dialogViewVisible
    },
    // 作废
    removeFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要作废的收款单', type: 'warning' })
        return
      } else if (args[0].status !== 1) {
        this.$message({ message: '收款单不在制单状态，不能作废', type: 'warning' })
        return
      }
      this.$confirm(
        '是否确定作废该收款单？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
      ).then(async () => {
        saveOrUpdateReceiveVoucherApi({ id: args[0].id, isDelete: "true" }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 复核
    checkFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要复核的收款单', type: 'warning' })
        return
      } else if (args[0].status !== 1) {
        this.$message({ message: '收款单不在制单状态，不能复核', type: 'warning' })
        return
      }
      this.$confirm(
        '是否确定复核该收款单？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
      ).then(async () => {
        saveOrUpdateReceiveVoucherApi({ id: args[0].id, isCheck: "true" }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 反复核
    unCheckFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要反复核的收款单', type: 'warning' })
        return
      } else if (args[0].status !== 2) {
        this.$message({ message: '收款单不在复核状态，不能反复核', type: 'warning' })
        return
      }
      this.$confirm(
        '是否确定反复核该收款单？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
      ).then(async () => {
        saveOrUpdateReceiveVoucherApi({ id: args[0].id, isUnCheck: "true" }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 导出数据API
    ExportByPage () {
      loadReceiveVoucherExportDataApi({ condition: JSON.stringify(this.exportObj) }).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
